module.exports = "<span>\n\t<p jf-tooltip=\"{{ $ctrl.showTooltip() ? 'Click for full text' : '' }}\"\n\t   ng-class=\"{'clickable': $ctrl.isTextOverflowing()}\"\n\t   ng-click=\"$ctrl.onTextClick()\"\n\t   data-ng-bind=\"$ctrl.text\"\n\t   data-ellipsis>\n\t</p>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./modules/distribution/directives/jf-abbraviated-text/abbraviated.text.view.html
// module id = 449
// module chunks = 6